let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2g0gm")).then(() => parcelRequire('lEMxW'));